module.exports = __webpack_public_path__ + "img/lens-174-minus-08.c276af0a.png";